import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PedidoDTO } from 'src/app/model/pedidoDTO';
import { PreviaPedidoDTO } from 'src/app/model/previaPedidoDTO';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gestion-pedido',
  templateUrl: './gestion-pedido.component.html',
  styleUrls: ['./gestion-pedido.component.css']
})
export class GestionPedidoComponent implements OnInit {
  pedidosdto:PedidoDTO[]=[];
  previapedidosdto:PreviaPedidoDTO[]=[];

  private url : string = `${environment.HOST}/api/`
   urlServerUpload$ : string = `${environment.HOST}/api/media/`

  constructor(
    private pedidoDTOService : PedidoDTOService,
    private router:Router,
    
    
    ){  }



    ngOnInit(): void {

      this.getPedidoNuevosDTO();
      
        }



    getPedidoNuevosDTO(){
      this.pedidoDTOService.getPedidoByNuevos(1).subscribe(response =>{
        console.log(response)
        return this.previapedidosdto=response
      })
    }

 
    OnSelectPedido(idpedido:any){
    
      this.router.navigate(['dashboard/gestion-pedido-detalle',idpedido])
    }
}
